module.exports = __webpack_public_path__ + "img/256x256_circle.693bebfc.svg";